import {ReactNode} from 'react';
import Header from '../../components/header/Header';
import {SettingsNav} from './SettingsLayout';

// Admin pages in the Settings frame. They have no mockups yet, so each keeps its own
// content and the route header (title, description, primary action) from Header.
export const AdminSettingsFrame = ({children}: { children: ReactNode }) => (
    <div className="flex h-[calc(100vh-var(--banner-height))] min-h-0">
        <SettingsNav/>
        <main className="flex min-w-0 flex-1 flex-col bg-surface">
            <Header inSettingsFrame/>
            <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
        </main>
    </div>
);
